import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Icon } from 'ui';

function PdfContentNavigation({ currentPage, disabled, isNextDisabled, isPreviousDisabled, onClickNext, onClickFullScreen, onClickPrevious, totalPages }) {
  const { t } = useTranslation();

  const prevDisabled = disabled || isPreviousDisabled;
  const nextDisabled = disabled || isNextDisabled;

  const isSinglePage = totalPages <= 1;

  return (
    <nav aria-label={t('common:Page navigation')} className="pdf-content-navigation">
      <div className="pdf-content-navigation__controls">
        {!isSinglePage && (
          <button
            aria-label={t('common:Previous page')}
            className={`pdf-content-navigation__button pdf-content-navigation__button--previous ${prevDisabled ? 'disabled' : 'hover-basic'}`}
            disabled={prevDisabled}
            onClick={onClickPrevious}
            type="button"
          >
            <Icon color={prevDisabled ? 'grey-04' : 'grey-03'} size="sm" name="chevron-left" />
          </button>
        )}

        <span className="pdf-content-navigation__page-counter">
          {currentPage}/{totalPages}
        </span>

        {!isSinglePage && (
          <button
            aria-label={t('common:Next page')}
            className={`pdf-content-navigation__button pdf-content-navigation__button--next ${nextDisabled ? 'disabled' : 'hover-basic'}`}
            disabled={nextDisabled}
            onClick={onClickNext}
            type="button"
          >
            <Icon color={nextDisabled ? 'grey-04' : 'grey-03'} size="sm" name="chevron-right" />
          </button>
        )}
      </div>
      {!isSinglePage && (
        <span aria-live="polite" className="visually-hidden">
          {t('common:Page x of y', { current: currentPage, total: totalPages })}
        </span>
      )}
      {onClickFullScreen && (
        <>
          <Button
            className="pdf-content-navigation__fullscreen--with-text"
            isDisabled={disabled}
            leftIcon="expand"
            iconSize="lg"
            onClick={onClickFullScreen}
            size="sm"
            text={t('common:View fullscreen')}
            variant="secondary"
          />
          <Button
            ariaLabel={t('common:View fullscreen')}
            className="pdf-content-navigation__fullscreen--icon-only"
            isDisabled={disabled}
            leftIcon="expand"
            iconSize="lg"
            onClick={onClickFullScreen}
            isIconOnly
            size="sm"
            variant="secondary"
          />
        </>
      )}
    </nav>
  );
}

PdfContentNavigation.propTypes = {
  currentPage: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  isNextDisabled: PropTypes.bool.isRequired,
  isPreviousDisabled: PropTypes.bool.isRequired,
  onClickFullScreen: PropTypes.func,
  onClickNext: PropTypes.func.isRequired,
  onClickPrevious: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
};

PdfContentNavigation.defaultProps = {
  disabled: false,
};

export default PdfContentNavigation;
